import { Box, IconButton, Typography, useTheme } from "@mui/material";
import { useContext, useState } from "react";
import { ColorModeContext, tokens } from "../../theme";
import { Menu, MenuItem } from "react-pro-sidebar";
import { Link } from "react-router-dom";


import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import NotificationsOutlinedIcon from "@mui/icons-material/NotificationsOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import logo from './AKlogo.png'
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";

import { SiHyperskill } from "react-icons/si";
import { PiProjectorScreenChartDuotone } from "react-icons/pi";
import { MdContactEmergency } from "react-icons/md";


const Topbar = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const colorMode = useContext(ColorModeContext);// eslint-disable-next-line
  const [selected, setSelected] = useState("Dashboard");




  return (
    <Box display="flex" justifyContent="space-between" p={2}

    >
      {/* SEARCH BAR */}
      <Box
        display="flex"
        backgroundColor={colors.primary[400]}
        borderRadius="50%"
        height={40}


      >
        <img src={logo} alt="Logo" />
      </Box>
      <Box display='flex' justifyContent='space-between' alignContent='center' >
        <Menu>
          <Box display='flex' justifyContent='center' alignItems='center' marginLeft={1} gap={2}>
            <Box display='flex' justifyContent='center' alignItems='center' gap={1}>
              <Link to='/' style={{textDecoration:"none"}} className="link" >
              <MenuItem icon={<HomeOutlinedIcon />} >
                <Typography>Home</Typography>
              </MenuItem>
              </Link>
            </Box>
            <Box display='flex' justifyContent='center' alignItems='center' gap={1} >
            <Link to='/skill' style={{textDecoration:"none"}}  className="link">
              <MenuItem icon={<SiHyperskill />}>
                <Typography>Skill</Typography>
              </MenuItem>
              </Link>
            </Box>
            <Box display='flex' justifyContent='center' alignItems='center' gap={1}>
            <Link to='/Projects' style={{textDecoration:"none"}} className="link">
              <MenuItem icon={<PiProjectorScreenChartDuotone />}>
                <Typography>Projects</Typography>
              </MenuItem>
              </Link>
            </Box>
            <Box display='flex' justifyContent='center' alignItems='center' gap={1}>
            <Link to='/Contact' style={{textDecoration:"none"}} className="link" >
              <MenuItem icon={<MdContactEmergency />}>
                <Typography>Contact Me</Typography>
              </MenuItem>
              </Link>
            </Box>
          </Box>
        </Menu>
      </Box>
      {/* ICONS */}
      <Box display="flex">
        <IconButton onClick={colorMode.toggleColorMode}>
          {theme.palette.mode === "dark" ? (
            <DarkModeOutlinedIcon />
          ) : (
            <LightModeOutlinedIcon />
          )}
        </IconButton>
        <IconButton>
          <NotificationsOutlinedIcon />
        </IconButton>
        <IconButton>
          <SettingsOutlinedIcon />
        </IconButton>
        <IconButton>
          <PersonOutlinedIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Topbar;
